import angular from 'angular';

class modalPreviewEmailCtrl {
  /* @ngInject */
  constructor(PrincipalSvc, logger) {
    this.PrincipalSvc = PrincipalSvc;
    this.logger = logger;
  }

  $onInit() {
    this.principal = this.resolve.principal;
    this.typeTemplate = this.resolve.typeTemplate;
    this.langCode = this.resolve.langCode;
    this.getTemplateEmail();
  }

  // Récupération du template Email
  getTemplateEmail() {
    var fileName = this.buildFileName(this.typeTemplate, this.langCode);
    this.PrincipalSvc.getEmailTemplate(fileName, this.principal.detail.id).then(
      result => {
        this.emailTemplateHtml = result.content;
        this.emailTemplateSubject = result.subject;
      },
      (/*error*/) => {
        //logger l'échec de récupération du template
        this.logger.error('error.import');
      }
    );
  }

  // Construire le nom du fichier
  buildFileName(typeTemplate, langCode) {
    return typeTemplate + '_' + langCode.toLowerCase();
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }
}

angular.module('app.principal').component('modalPreviewEmail', {
  templateUrl: require('./modal-preview-email.html'),
  controller: modalPreviewEmailCtrl,
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
});
